import MfaForm from "../components/MfaForm"
import styles from "../styles/ChangePasswordPage.module.css"

export default function MfaChallenge() {

    return (
        <div className={styles.generalContainer}>
            <div className={styles.card}>
                <div className={styles.logoContainer}>
                    <img src="images/cs-loginSoyMomoImage.svg" width={100} height={100} className={styles.momoImg} alt="SoyMomo logo"/>
                </div>

                <h1 className={styles.title}>Verificación en dos pasos</h1>

                <MfaForm/>

                <img src="images/cs-loginSoyMomoLogo.svg" width={100} height={100} className={styles.logo} alt="logo"/>
            </div>
        </div>
    )
}
